import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags"
import {Card, CardBody, CardTitle, Col, Container, Row} from "reactstrap";
import "./datatables.scss"
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
    PaginationProvider, PaginationListStandalone,
    SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import {Link} from "react-router-dom";
import axios from "axios";
import config from "../../config";
import ModalConfirm from "../../components/ModalConfirm";
import TableSearchBar from "../../components/TableSearchBar";
import { useToasts } from "react-toast-notifications";
import LookButtons from '../../components/LookButtons'
import WV from '../../workVariables'

const UnionSchemas = () => {
    const { addToast } = useToasts()
  
    const ActionButtons = (props) => {
        const copyItem = async (id) => {
                await axios.get(`${config.apiUrl}/union-schemas-copy/${id}`)
                .then(async (response) => {
                    console.log(response.data.msg);
                    addToast(response.data.msg, {
                        appearance: response.data.res.toLowerCase(),
                        autoDismiss: true,
                        autoDismissTimeout: 7500,
                        transitionDuration: 2000
                    })
                    if (response.data.res === "Success") {
                        const response = await axios.get(`${config.apiUrl}/union-schemas`)
                        setTestSchema(response.data)
                    }

                    // <Redirect to="/account" />

                })
                .catch(error => {
                    console.error(error);
                })
        }
        return (
            <div className='d-flex gap-2'>
                <Link to={`/union-schemas/show/${props.id}`} className='btn btn-secondary' title='Просмотр'>
                    <i class="far fa-eye" />
                </Link>
                <Link to={`/union-schemas/edit/${props.id}`} className='btn btn-primary' title='Редактировать'>
                    <i className='mdi mdi-pencil' />
                </Link>
                <div className='d-flex gap-2'>
                    <button onClick={() => copyItem(props.id)} className='btn btn-success' title='Дублировать'><i className='mdi mdi-content-copy' /></button>
                </div>
                <div className='d-flex gap-2'>
                <button
                        onClick={() => {
                            setModalConfirm(true)
                            setDeleteId(props.id)
                        }
                        }
                        className='btn btn-danger' title='Удалить'>
                        <i className='mdi mdi-delete' />
                    </button>
                    {/* <button onClick={() => removeItem(props.id)} className='btn btn-danger' title='Удалить'><i className='mdi mdi-delete' /></button> */}
                </div>
           </div>
        )

    }
    const [testSchema, setTestSchema] = useState([])
    const [tableData, setTableData] = useState([])
    const columns = [
        {
            dataField: 'id',
            text: 'Id',
            sort: true,
        },
        {
            dataField: 'name',
            text: 'Название',
            sort: true
        },
        {
            dataField: 'scheme',
            text: 'Схемы 2.0',
            sort: true
        },
        {
            dataField: 'period',
            text: 'Период',
            sort: true
        },
        {
            dataField: 'count_strategy',
            text: 'Количество стратегий',
            sort: true
        },
        {
            dataField: 'comment',
            text: 'Комментарии',
            sort: true
        },
        {
            dataField: 'actions',
            text: 'Действия',
            sort: false,
            style: {
                width: 111,
            }
        },

        
    ];
    useEffect(() => {
        const getTestScheme = async () => {
            const response = await axios.get(`${config.apiUrl}/union-schemas`)
            console.log(response.data);
            setTestSchema(response.data)
        }
        getTestScheme()
    }, [])
      
    useEffect(() => {
        let tableData = []
            function TSList(props) {
                const list = props.list;
                const listItems = list.map((item) =>
                    <li style={{ listStyle: "none" }}>
                        <LookButtons url='/test2/show/'
                            id={item.id}
                            title='Посмотреть тестовую схему'
                            lable={item.name} />
                    </li>
                );
                return (
                    <ul>{listItems}</ul>
                );
            }
            
       
        if (testSchema.length > 0) {
            testSchema.forEach(itemSchema => {
                let ts = itemSchema.scheme
                if (itemSchema.comment) {
                    if (itemSchema.comment.length > WV.longCommentTest)
                        itemSchema.comment = itemSchema.comment.substr(0, WV.longCommentTest) + ' ...'
                }  
                tableData.push({
                    ...itemSchema,
                    "scheme": (
                        <TSList list={ts} />
                    ),
                    "actions": (<ActionButtons id={itemSchema.id} />)
                })
            })            
        }       
        setTableData(tableData)
    }, [testSchema])
   
    const defaultSorted = [{
        dataField: 'id',
        order: 'desc'
    }];

    const sizePerPageList = WV.sizePerPageArr.concat([{ text: 'Все', value: (tableData).length }])
    let nameTable = 'tableSet_union'
    let sizePerPage = parseInt(localStorage.getItem(nameTable + 'perPage'));
    if (!sizePerPage) sizePerPage = parseInt(WV.sizePerPage);
    let page = parseInt(localStorage.getItem(nameTable + 'page'));
    if (!page) page = 1;
    const pageOptions = {
        sizePerPage: sizePerPage,
        page: page,
        sizePerPageList: sizePerPageList,
        totalSize: tableData.length,
        custom: true,
        onSizePerPageChange: (sizePerPage, page) => {
            localStorage.setItem(nameTable + 'perPage', sizePerPage)
            localStorage.setItem(nameTable + 'page', 1)
        },
        onPageChange: (page, sizePerPage) => {
            localStorage.setItem(nameTable + 'page', page)
        },
    }

    // Select All Button operation
    // const selectRow = {
    //     mode: 'checkbox'
    // }

    const [modalConfirm, setModalConfirm] = useState(false)
    const [deleteId, setDeleteId] = useState(null)
    const toggleModalConfirm = () => {
        setModalConfirm(!modalConfirm)
    }
    const removeItem = async (id) => {
        await axios.get(`${config.apiUrl}/union-schemas-delete/${id}`)
            .then((response) => {
                console.log(response.data.msg);
                addToast(response.data.msg, {
                    appearance: response.data.res.toLowerCase(),
                    autoDismiss: true,
                    autoDismissTimeout: 7500,
                    transitionDuration: 2000
                })
                if (response.data.res === "Success") {
                    setTestSchema(testSchema.filter(item => item.id !== id))
                }
            })
            .catch(error => {
                console.error(error);
            })

    }    

    return (
        <div className="page-content">
            <MetaTags>
                <title>Объединение схем | TradeBot</title>
            </MetaTags>
            <Container fluid>
                <Row>
                    <Col className="col-12">
                        <Card>
                            <CardBody>
                                <CardTitle>
                                    <div className='mb-3 d-flex justify-content-between align-items-center'>
                                        <h4>Объединение схем</h4>
                                        <Link to='/union-schemas/add' className='btn btn-primary'>
                                            <i className='mdi mdi-plus'/>
                                            Добавить
                                        </Link>
                                    </div>
                                </CardTitle>
                                <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField='id'
                                    sizePerPageList={sizePerPageList}
                                    columns={columns}
                                    data={tableData}
                                >
                                    {({ paginationProps, paginationTableProps }) => (
                                        <ToolkitProvider
                                            keyField='id'
                                            columns={columns}
                                            data={tableData}
                                            search
                                        >
                                            {toolkitProps => (
                                                <React.Fragment>

                                                    <Row className="mb-2">
                                                        <Col md="4">
                                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                                <div className="position-relative">
                                                                    <TableSearchBar
                                                                        {...toolkitProps.searchProps}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl="12">
                                                            <div className="table-responsive">
                                                                <BootstrapTable
                                                                    keyField={"id"}
                                                                    responsive
                                                                    bordered={true}
                                                                    striped={true}
                                                                    defaultSorted={defaultSorted}
                                                                    classes={
                                                                        "table align-middle table-nowrap"
                                                                    }
                                                                    headerWrapperClasses={"thead-light"}
                                                                    {...toolkitProps.baseProps}
                                                                    {...paginationTableProps}
                                                                />

                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row className="align-items-md-center mt-30">
                                                        <Col className="inner-custom-pagination d-flex">
                                                            <div className="d-inline">
                                                                <SizePerPageDropdownStandalone
                                                                    sizePerPageList={sizePerPageList}
                                                                    {...paginationProps}
                                                                />
                                                            </div>
                                                            <div className="text-md-right ms-auto">
                                                                <PaginationListStandalone
                                                                    {...paginationProps}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </React.Fragment>
                                            )
                                            }
                                        </ToolkitProvider>
                                    )
                                    }</PaginationProvider>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ModalConfirm
                modalConfirm={modalConfirm}
                toggleModalConfirm={toggleModalConfirm}
                removeItem={removeItem}
                deleteId={deleteId}
                lebel='Удаление объединение схем'
            />
        </div>
    )
}

export default UnionSchemas
